export const dodoCurrencies = [
  'USD',
  'AED',
  'ALL',
  'AMD',
  'ARS',
  'AUD',
  'AWG',
  'AZN',
  'BAM',
  'BDT',
  'BMD',
  'BND',
  'BOB',
  'BRL',
  'BSD',
  'BWP',
  'BZD',
  'CAD',
  'CHF',
  'CLP',
  'CNY',
  'CRC',
  'CZK',
  'DKK',
  'DOP',
  'EGP',
  'ETB',
  'EUR',
  'FJD',
  'GBP',
  'GEL',
  'GMD',
  'GTQ',
  'GYD',
  'HKD',
  'HNL',
  'HUF',
  'IDR',
  'ILS',
  'INR',
  'KZT',
  'LKR',
  'LRD',
  'LSL',
  'MAD',
  'MKD',
  'MOP',
  'MUR',
  'MVR',
  'MWK',
  'MXN',
  'MYR',
  'NGN',
  'NOK',
  'NPR',
  'NZD',
  'PEN',
  'PGK',
  'PHP',
  'PLN',
  'QAR',
  'RON',
  'RSD',
  'SAR',
  'SBD',
  'SCR',
  'SEK',
  'SGD',
  'SZL',
  'THB',
  'TOP',
  'TRY',
  'TWD',
  'TZS',
  'UYU',
  'WST',
  'ZAR',
  'ZMW',
] as const;

export type DodoCurrency = (typeof dodoCurrencies)[number];

export function isDodoCurrency(value: string): value is DodoCurrency {
  return dodoCurrencies.includes(value.toUpperCase() as DodoCurrency);
}
